<svelte:options accessors={true}/>
<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import ReportsService from "../services/reports.service";
    import Loader from "../components/Loader.svelte";
    import EditableCell from "../components/EditableCell.svelte";
    import AuthService from '../services/auth.service.js';
    import {formatValue, cleanValue} from '../helpers/format.helper';
    import {getPastDateData, getPtqrCellStyle, stylesList} from '../helpers/style.helper';
    import ExportService from "../services/export.service";
    import ColorPicker from "../components/ColorPicker.svelte";
    import EmployeeActivity from "../components/EmployeeActivity.svelte";
    import { getValidMonthsForYTD, calculateTotal } from '../services/reports.service.js';

    let teams, org_employees, metrics, headers, loading = false, saveTried = true, saveTriedAlert = false,
        employeeToChange = {}, deleteConfirmation = false, badDatesError = false,
        errorMessage,
        teamName = '',
        deletedItems = [],
        disableButton = false,
        disableSaveButton = false,
        currentEmployee = {}, teamToChange = {}, currentTeam = {},
        selectedTeam = null,
        teamDragged,
        employeeDragged,
        categoryInfo,
        allowDrag = false,
        search = "",
        currentPage = 0,
        entries = 100,
        sortBy = "id",
        order = true,
        selectedEmployee,
        draggedId = null,
        organizationEmployees = [],
        selectedRole = null,
        roleMetricsTab = 'metrics',
        roleActivityNotes = '',

        roleFilter = null,
        dispatch = createEventDispatcher(),
        localIndicatorFields = [],
        isActivityReport = false,
        ytdValues = {},
        activityYTDValues = {},
        storedResultData = null,
        teamMetrics = {};


    export let user, params, options, loadingExport = false, selectedActivity;

    const formatTitles = [
        'Numeric', 'Currency ($)', 'Percentage (%)', 'Days', 'Multiplier (x)', 'B.P.S. (bps)'
    ];

    const ytdFormulasTitles = {
        'SUM': 'Summation',
        'AVG': 'Average'
    };

    const attainmentHeaders = {
        "onboard_month": { title: "ONBOARD MONTH", format: 0},
        "onboard_perf": { title: "ONBOARD PERF", format: 7 },
        "ramped_month": { title: "RAMPED MONTH", format: 0 }
    };

    $: loadData(params, search, entries, currentPage, order, sortBy, entries);
    $: allowDrag = !['attainment'].includes(params.subMenu);
    $: employeeData = selectedEmployee && selectedEmployee.id ? selectedEmployee : currentEmployee;
    $: isActivityReport = params.subMenu === 'activity';

    $: if (selectedActivity) {
        updateLocalIndicatorFields();
        setTimeout(() => {
            enableTableSelection();
            tablesLoaded();
            console.log('enable selection:', );
        }, 250);
    }

    export async function loadData() {
        if (loading) return;
        loading = true;
        selectedTeam = null;
        deleteConfirmation = false;
        const url = '/org/' + params.org + '/employees/' + params.subMenu + '/date/' + params.year;
        let result = null;
        storedResultData = null;
        //Scroll to previous position
        setTimeout(() => {
            var scrolled = (localStorage.getItem('scrolled')) ? localStorage.getItem('scrolled') : 0;
            jQuery('#reportsDiv').scrollTop(scrolled);
            localStorage.setItem("scrolled", 0);
        }, 500);
        teams = [];
        try {
            result = await ReportsService.load(url);
        } catch (e) {
            teams = null;
        }

        if (result && result.data && result.data.headers) {
            storedResultData = result.data;
            teams = result.data.teams;
            org_employees = result.data.org_employees;
            headers = result.data.headers;
            metrics = result.data.metrics;
            teamMetrics = result.data.teamMetrics;
            updateEmployeeYTDs(teams, params.year);
            dispatch('loaded', teams);
        }

        loading = false;

        setTimeout(() => {
            jQuery('.sticky-thead').removeClass('d-none');
            tablesLoaded();
            enableTableSelection();
        }, 500);
    }

    onMount(async () => {
        cleanEmployee();
        await loadData();
    });

    function getRows(employeesCount) {
        var rows = [];
        for (let i = 0; i < 1 - employeesCount; i++) {
            rows.push(i);
        }
        return rows;
    }

    let saveEmployeeStat = function (value, employee_id, date) {
        ReportsService.saveEmployeeStat({
            employee_id,
            date: new Date(date + "/01").toISOString(),
            quota: params.subMenu === 'quota' ? value : undefined,
            performance: params.subMenu === 'performance' ? value : undefined,
            pipeline: params.subMenu === 'pipeline' ? value : undefined,
        });
        
        updateEmployeeYTDs(teams, params.year);
    }

    let saveEmployeeFields = async function (value, employee_id, field) {
        let employeeUpdated = {
            "id": employee_id
        };
        employeeUpdated[field] = value;
        await ReportsService.updateEmployee(employeeUpdated);
    }

    let onSaveEmployee = async function () {
        let finalMetrics = [];

        if (employeeData.metrics && employeeData.metrics.length > 0) {
            employeeData.metrics.forEach(metric => {
                finalMetrics.push(metric);
            });

            delete employeeData.metrics;
        }

        if (!currentEmployee.name || !currentEmployee.position || !currentEmployee.start_date) {
            saveTried = true;
            saveTriedAlert = true;
            setTimeout(() => {
                saveTriedAlert = false;
            }, 3000);
        } else {
            if (currentEmployee.end_date && !(currentEmployee.start_date <= currentEmployee.end_date)) {
                badDatesError = true;

                setTimeout(() => {
                    badDatesError = false;
                }, 3000);
            } else {
                disableSaveButton = true;
                errorMessage = null;

                try {
                    if (currentEmployee.id) {
                        if (JSON.stringify(employeeToChange) != JSON.stringify(currentEmployee)) {
                            await ReportsService.updateEmployee(currentEmployee);
                        }
                    } else {
                        await ReportsService.saveEmployee(currentEmployee);
                    }

                    if (currentEmployee && currentEmployee.id) {
                        await ReportsService.saveEmployeeMetrics(currentEmployee.id, finalMetrics);
                    }

                    await loadData();

                    disableSaveButton = false;
                    jQuery('#addEmployee').modal('hide');
                    cleanEmployee();
                } catch (e) {
                    errorMessage = e.message;
                }
            }
        }
    }

    let onSaveTeam = async function () {
        disableSaveButton = true;
        errorMessage = null;

        try {
            if (currentTeam.id) {
                if (JSON.stringify(teamToChange) != JSON.stringify(currentTeam)) {
                    await ReportsService.updateTeam(currentTeam, params.subMenu);
                    loadData();
                }
            } else {
                await ReportsService.saveTeam(currentTeam, params.subMenu);
                loadData();
            }
            disableSaveButton = false;
            jQuery('#editTeam').modal('hide');
            currentTeam = {}; //"Clean" it
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onDeleteEmployee = async function () {
        errorMessage = null;
        disableButton = true;

        try {
            if (params.subMenu === 'activity') {
                delete employeeData.metrics;
                await ReportsService.deleteEmployeeMetrics(currentEmployee.id);
            } else {
                await ReportsService.deleteEmployee(currentEmployee.id);
            }
            jQuery('#addEmployee').modal('hide');
            deleteConfirmation = false;
            cleanEmployee();
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onDeleteTeam = async function () {
        disableButton = true;
        errorMessage = null;

        try {
            await ReportsService.deleteTeam(currentTeam.id);
            jQuery('#editTeam').modal('hide');
            deleteConfirmation = false;
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    async function changeTeamPosition(teamId, newPosition) {
        if (selectedTeam != teamId) {
            try {
                await ReportsService.updateTeamPosition({id: selectedTeam, position: newPosition});
                loadData();
            } catch (e) {
                console.log(e);
            }
        }
        selectedTeam = null;
    }

    function onSelectTeam(teamId) {
        selectedTeam = teamId;
        jQuery('.sticky-thead').addClass('d-none');
    }

    let setDeleteConfirmation = function () {
        deleteConfirmation = true;
        setTimeout(() => {
            if (deleteConfirmation) deleteConfirmation = false;
        }, 10000);
    }

    function cleanEmployee() {
        currentEmployee = {
            name: '',
            position: '',
            format: 0,
            team_id: null,
            notes: ''
        };
        saveTried = false;
    }

    function cleanTeam() {
        currentTeam = {
            title: "",
            organization_id: params.org,
            ytd_formula: null
        };
    }

    async function fillEmployee(team) {
        cleanEmployee();
        teamName = team.title;
        currentEmployee.team_id = team.id;
        jQuery('#addEmployee').modal('show');

        if (params.subMenu === 'activity') {
            selectedRole = team;
            await getEmployeeMetrics();
            jQuery('#metrics-tab').click();
        } else {
            jQuery('#kpi-tab').click();
        }
    }

    async function editEmployee(e, employee, team) {
        currentEmployee = employee;
        deleteConfirmation = false;
        disableButton = false;
        saveTried = false;

        if (currentEmployee.start_date_formatted) {
            var startDateSplitted = currentEmployee.start_date_formatted.split("/");
            currentEmployee.start_date = startDateSplitted[2] + "-" + startDateSplitted[0] + "-" + startDateSplitted[1];
        }

        if (currentEmployee.end_date_formatted) {
            var endDateSplitted = currentEmployee.end_date_formatted.split("/");
            currentEmployee.end_date = endDateSplitted[2] + "-" + endDateSplitted[0] + "-" + endDateSplitted[1];
        }
        employeeToChange = {...currentEmployee};
        jQuery('#addEmployee').modal('show');

        if (params.subMenu === 'activity') {
            selectedRole = team;
            await getRoleMetrics();
            await getEmployeeMetrics();
            metrics = metrics;
            jQuery('#metrics-tab').click();
        } else {
            jQuery('#kpi-tab').click();
        }
    }

    function editTeam(team) {
        currentTeam = team;
        deleteConfirmation = false;
        disableButton = false;
        teamToChange = {...currentTeam}; //Used to verify if at least a field change
        jQuery('#editTeam').modal('show');
    }

    export function addSection() {
        cleanTeam();
        jQuery('#editTeam').modal('show');
    }


    export async function exportToExcel(allPortcos = false) {
        if (params.subMenu === 'activity') return exportActivityReport();
        const isFacilitator = (AuthService.can('EXPORT_HR_ALL_PORTCOS') && allPortcos)?false : true;
        const urlToExport = '/org/' + params.org + getExportUrl(isFacilitator) + params.year;
        const fileName = (!isFacilitator)? 'Individual -' + params.year:`Individual-${jQuery('#dropdownOrganizations').text()}` + "-" + params.year;
        const isCurrentYear = params.year === new Date().getFullYear().toString();

        let result = null;
        loadingExport = true;
        try {
            result = await ReportsService.load(urlToExport);
            if (result && result.data) {
                if(isFacilitator){
                    await ExportService.downloadTeams(result.data.teams, user.name, fileName, options.org.ptqr_rolling_months, isCurrentYear);
                }else{
                    // All portcos report
                    await ExportService.downloadIndividualAllPortcos(result.data.employees, user.name, fileName, result.data.rollingMonths, isCurrentYear);
                }
            } else {
                alert('No sections found');
            }
        } catch (e) {
            alert('Download error!');
            console.log('Error', e);
        }

        loadingExport = false;
    }

    async function exportActivityReport() {
        loadingExport = true;

        try {

            if (storedResultData) {
                const FILENAME = 'Employee activity by ' + selectedActivity + ' - ' + params.year;
                if (selectedActivity === 'metrics') {    
                    await ExportService.exportISRActivityByMetric(storedResultData, user.name, FILENAME, activityYTDValues);
                } else {
                    await ExportService.exportISRActivityByEmployee(storedResultData, user.name, FILENAME);
                }
            }
        } catch (error) {
            //
        } finally {
            loadingExport = false;
        }
        return;
    }

    function getExportUrl(isFacilitator){
        return (isFacilitator) ? '/export/individual/date/' : '/export/individual_all_portcos/date/';
    }

    function getDate(date) {
        let months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let fixDate = date.split('/');

        return months.indexOf(fixDate[0]).toString().padStart(2, '0') + '/01/' + fixDate[1];
    }

    function calculateYTD(employeeData, team, year) {
        if (!employeeData || !team) return 0;
        const validHeaders = getValidMonthsForYTD(Object.keys(employeeData), year, 'YTD');
        const values = validHeaders.map(h => {
            const value = employeeData[h];
            return (value !== null && value !== undefined && value !== '') ? parseFloat(value) || 0 : null;
        });
        return calculateTotal(values, team.ytd_formula);
    }

    function updateEmployeeYTDs(teams, year) {
        if (!teams || !['quota', 'performance'].includes(params.subMenu)) return;

        teams.forEach(team => {
            if (!team.employees) return;
            team.employees.forEach(employee => {
                if (!employee.employeeData) return;
                ytdValues[employee.id] = calculateYTD(employee.employeeData, team, year);
            });
        });
    }

    function handleDragStart(e, id, teamId) {
        if (!allowDrag) return;
        teamDragged = teamId;
        employeeDragged = id;
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.setData("text", id);
        draggedId = id;
    }

    function handleDragEnter(e) {
        e.dataTransfer.dropEffect = 'move';
        window.jQuery(e.target).css('border-top', '2px dashed #fdc59b');
        window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
    }

    function handleDragLeave(e) {
        window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        window.jQuery(e.target).css('border-bottom', '1px solid #dee2e6');
        window.jQuery(e.target).css('box-shadow', 'none');
    }

    /**
     * Handle the drag over event to show the drop effect
     */
    function handleDragOver(e) {
        e.dataTransfer.dropEffect = 'move';

        if (ReportsService.isElementTopPosition(e)) {
            window.jQuery(e.target).css('border-top', '3px dashed #fdc59b');
            window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
            window.jQuery(e.target).css('border-bottom', '1px solid #dee2e6');
        } else {
            window.jQuery(e.target).css('border-bottom', '3px dashed #fdc59b');
            window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
            window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        }
        e.preventDefault();
    }

    async function handleDrop(e, team_id, position) {
        if (!allowDrag) return;
        e.preventDefault();

        // remove borders styles
        e.target.style.borderTop = '';
        e.target.style.borderBottom = '';

        let id = e.dataTransfer.getData('text');

        // Add element below the target
        if (!ReportsService.isElementTopPosition(e)) position++;

        try {
            await ReportsService.updateEmployeePosition({id, team_id, position});
            loadData();
        } catch (e) {
            console.log(e);
        }
    }

    let openCategoryInfo = function(category){
        categoryInfo = category;
        jQuery('#categoryInfoModal').modal('show');
    }

    function handleEmployeeSelect(event) {
        selectedEmployee = event.detail;
    }

    export const onSearch = function(searchText) {
        search = searchText;
    }

    export const onRoleFilter = function (role) {
        roleFilter = role;
    }

    export function addEmployee() {
        cleanEmployee();
        teamName = 'Any team';
        currentEmployee.team_id = null;
        selectedRole = null;
        jQuery('#addEmployee').modal('show');
        jQuery('#kpi-tab').click();
    }

    function selectRole(role) {
        roleActivityNotes = role.activity_notes || '';
        selectedRole = role;
        roleMetricsTab = 'metrics';
        jQuery('#roleActivityMetricsModal').modal('show');
        getRoleMetrics();
    }

    async function getRoleMetrics() {
        if (selectedRole && selectedRole.id) {
            try {
                const result = await ReportsService.getRoleMetrics(selectedRole.id);
                selectedRole.metrics = [...result.data.data];
                selectedRole = selectedRole;
                metrics = metrics;
            } catch (e) {
                console.error('Error:', e);
            }
        }
    }

    function selectOrganizationEmployee(orgEmployee) {
        if (orgEmployee && orgEmployee.id) {
            editEmployee(null, orgEmployee);
            teamName = orgEmployee.team? orgEmployee.team.title: '---';
            employeeData.metrics = [];
        }
    }

    async function getOrganizationEmployees() {
        const result = await ReportsService.getOrganizationEmployees(params.org);
        if (result && result.data && result.data.data) {
            organizationEmployees = result.data.data;
        }
    }

    async function getEmployeeMetrics() {
        if (employeeData && employeeData.id) {
            try {
                const result = await ReportsService.getEmployeeMetrics(employeeData.id);
                employeeData.metrics = result.data && result.data.data? result.data.data: [];
                employeeData.metrics = employeeData.metrics;
                employeeData = employeeData;
            } catch (e) {
                console.error('Error:', e);
            }

        }
    }

    function toggleEmployeeMetric(metric) {
        if (employeeData && metric && metric.id) {
            if (isSelectedMetric(metric.id)) {
                const metricPosition = employeeData.metrics.findIndex(item => item.metric_id === metric.id);
                employeeData.metrics.splice(metricPosition, 1);
            } else {
                employeeData.metrics.push({
                    metric_id: metric.id,
                    employee_id: employeeData.id,
                    show_budget: true
                });
            }

            employeeData.metrics = employeeData.metrics;
            employeeData = employeeData;
            metrics = metrics;
        }
    }

    function isSelectedMetric(metricID) {
        if (!employeeData || !employeeData.metrics) return false;

        const result = employeeData.metrics.findIndex(item => item.metric_id === metricID) >= 0;
        return result;
    }


    function toggleEmployeeMetricBudget(metricID) {
        if (!employeeData || !employeeData.metrics) return;

        const employeeMetric = employeeData.metrics.find(item => item.metric_id === metricID );

        employeeMetric.show_budget = employeeHasMetricID(metricID)? 0: 1;

        employeeData.metrics = employeeData.metrics;
        employeeData = employeeData;
        metrics = metrics;
    }

    function employeeHasMetricID(metricID) {
        if (!employeeData || !employeeData.metrics) return true;

        return employeeData.metrics.findIndex(item => item.metric_id === metricID && item.show_budget) >= 0;
    }

    function toggleRoleMetric(metric) {
        if (selectedRole && metric && metric.id) {
            if (roleHasMetricID(metric.id)) {
                const metricPosition = selectedRole.metrics.findIndex(item => item.metric_id === metric.id);
                selectedRole.metrics.splice(metricPosition, 1);
            } else {
                if (!selectedRole.metrics) selectedRole.metrics = [];

                selectedRole.metrics.push({
                    metric_id: metric.id,
                    role_id: selectedRole.id,
                    show_budget: metric.show_budget
                });
            }
            selectedRole.metrics = selectedRole.metrics;
            selectedRole = selectedRole;
            metrics = metrics;
        }
    }

    function roleHasMetricID(metricID) {
        if (!selectedRole || !selectedRole.metrics) return false;
        return selectedRole.metrics.findIndex(item => item.metric_id === metricID) >= 0;
    }

    async function saveRoleMetrics() {
        if (selectedRole && selectedRole.metrics) {
            let payload = selectedRole.metrics;
            if (selectedRole.id) {
                payload = {
                    metrics: selectedRole.metrics,
                    activity_notes: roleActivityNotes
                };
            }
            await ReportsService.saveRoleMetrics(selectedRole.id, payload);
            await loadData();
            jQuery('#roleActivityMetricsModal').modal('hide');
        }
    }

    function getRoleMetricByID(metricID) {
        if (!selectedRole || !selectedRole.metrics) return;

        return selectedRole.metrics.filter(item => item.metric_id === metricID)[0];
    }

    function toggleMetricBudget(metricID) {
        const metric = getRoleMetricByID(metricID);

        if (!metric) return;

        metric.show_budget = !metric.show_budget;
        metrics = metrics;
        selectedRole = selectedRole;

        console.log('metric', metric);
    }

    /**
     * Update local indicator fields on changing report view
     * @param {Array} data - Array of objects containing the updated data
     */
     const updateLocalIndicatorFields = () => {
        localIndicatorFields.forEach((item) => {
            const team = teams.find(t => t.id === item.team_id);
            if (team) {
                const employee = team.employees.find(emp => emp.id === item.employee_id);
                if (employee) {
                    const metric = employee.metrics.find(m => m.id === item.metric_id);
                    if (metric && metric.data && metric.data[item.date]) {
                        if (item.field === 'actual') {
                            metric.data[item.date].actual_imported = 0;
                        } else {
                            metric.data[item.date].budget_imported = 0;
                        }
                    }
                }
            }
        });
        localIndicatorFields = [];
    };

    async function saveMetricNotes(metric) {
        await ReportsService.updateMetricNotes(metric.id, metric.team_id, { notes: metric.notes });
        loadData();
    }
</script>
<button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>
{#if AuthService.can('EXPORT_HR_ALL_PORTCOS')}
    <div id="popover-export" class="comment-popover d-none">
        This report typically takes 1-2 minutes <br>to download. Please be patient.
    </div>
{/if}

<div class="modal fade" id="addEmployee" tabindex="-1" role="dialog" aria-labelledby="addEmployeeLabel"
     aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    {#if selectedRole && selectedRole.id && params.subMenu === 'activity'}
                        {employeeData.name}'s Metrics
                    {:else}
                        {#if currentEmployee.id}
                            Edit Employee
                        {:else}
                            <span class="text-muted">Add New Employee to</span>
                            <em class="text-dark bg-warning px-1">{teamName}</em>
                        {/if}
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('ANNOTATE_KPI') }
                    {#if selectedRole && selectedRole.id && params.subMenu === 'activity'}
                        <p>
                            Check the metrics that will display the <strong class="alert-warning text-dark">BUDGET</strong> for <strong> <br>
                            {employeeData.name}</strong>.
                        </p>
                        <div class="form-group pl-4">
                            {#if metrics && metrics.length > 0}
                                {#each metrics as metric}
                                    {#if roleHasMetricID(metric.id)}
                                        <div class="form-check"
                                             on:click|stopPropagation|preventDefault={() => toggleEmployeeMetricBudget(metric.id) }>
                                            {#if employeeHasMetricID(metric.id)}
                                                <input class="form-check-input" type="checkbox" id="metric-{metric.id}" checked />
                                            {:else}
                                                <input class="form-check-input" type="checkbox" id="metric-{metric.id}" />
                                            {/if}
                                            <label class="form-check-label text-{employeeHasMetricID(metric.id)? 'dark' : 'muted'}"
                                                   for="metric-{metric.id}">
                                                {metric.title}
                                            </label>
                                        </div>
                                    {/if}
                                {/each}
                            {/if}
                        </div>
                    {:else}
                        <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="kpi-tab"
                                   data-toggle="tab" href="#kpi" role="tab" aria-controls="kpi" aria-selected="true">
                                    Employee
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="notes-tab"
                                   data-toggle="tab" href="#notes" role="tab" aria-controls="notes" aria-selected="false">
                                    Notes
                                </a>
                            </li>
                        </ul>
                    {/if}
                {/if}
                {#if saveTriedAlert}
                    <div class="alert alert-danger" role="alert">
                        Please fill in all required fields
                        <button type="button" class="close" on:click={ () => saveTriedAlert = false}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                {:else if badDatesError}
                    <div class="alert alert-danger" role="alert">
                        Start date must be earlier or equal to end date
                        <button type="button" class="close" on:click={ () => badDatesError = false}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                {/if}
                <form>
                    <div class="tab-content" id="myTabContent">
                        {#if params.subMenu !== 'activity' || !selectedRole || !selectedRole.id}
                            <div class="tab-pane fade show active" id="kpi" role="tabpanel" aria-labelledby="kpi-tab">
                                {#if employeeData}
                                    {#if employeeData.id}
                                        <div class="form-group">
                                            <strong>User ID:</strong> {employeeData.id}
                                        </div>
                                    {/if}

                                    {#if !employeeData.id && params.subMenu === 'activity'}
                                        <div class="btn-group mb-3">
                                            <button class="btn btn-secondary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton"
                                                    on:click={getOrganizationEmployees}
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Select an employee
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                {#if organizationEmployees.length === 0}
                                                    <div class="dropdown-item">No employees found. Please add more employees.</div>
                                                {:else}
                                                    {#each organizationEmployees as orgEmployee}
                                                        <a class="dropdown-item"
                                                           on:click={() => selectOrganizationEmployee(orgEmployee)}>{orgEmployee.name}</a>
                                                    {/each}
                                                {/if}
                                            </div>
                                        </div>
                                    {:else}
                                        <div class="form-group">
                                            <label for="nameInput">*Name:</label>
                                            <input disabled={isActivityReport} bind:value={employeeData.name} maxlength="64" type="text" class="form-control" id="nameInput" placeholder="John Doe" />
                                            {#if saveTried && !employeeData.name}
                                                <small class="text-danger ml-2 font-weight-bold">Name is required</small>
                                            {/if}
                                        </div>
                                        <div class="form-group">
                                            <label for="positionInput">*Position</label>
                                            <input disabled={isActivityReport} bind:value={employeeData.position} type="text" class="form-control" id="positionInput" maxlength="40" required placeholder="Management" />
                                            {#if saveTried && !employeeData.position}
                                                <small class="text-danger ml-2 font-weight-bold">Position is required</small>
                                            {/if}
                                        </div>
                                        <div class="form-group">
                                            <label for="dateInput">*Start Date: </label>
                                            <input disabled={isActivityReport} bind:value={employeeData.start_date} type="date" class="form-control" id="dateInput" data-date-format="DD/MMMM/YYYY" placeholder="mm/dd/yyyy" />
                                            {#if saveTried && !employeeData.start_date}
                                                <small class="text-danger ml-2 font-weight-bold">Start date is required</small>
                                            {/if}
                                        </div>
                                        <div class="form-group">
                                            <label for="dateInput">End Date:</label>
                                            <input disabled={isActivityReport} bind:value={employeeData.end_date} min="2020-05-25" type="date" class="form-control" id="endDate" data-date-format="DD/MMMM/YYYY" placeholder="mm/dd/yyyy" />
                                        </div>
                                    {/if}
                                {/if}
                            </div>
                            <div class="tab-pane fade" id="notes" role="tabpanel" aria-labelledby="notes-tab">
                                <div class="form-group">
                                    <label for="notesInput">Notes</label>
                                    <textarea bind:value={employeeData.notes} type="text" class="form-control"
                                              id="notesInput" placeholder="Notes" rows="10"></textarea>
                                </div>
                            </div>
                        {/if}
                    </div>
                </form>
            </div>
            {#if errorMessage}
                <div class="alert alert-danger">
                    ERROR: {errorMessage}
                </div>
            {/if}
            <div class="modal-footer">
                {#if AuthService.can('DELETE_EMPLOYEE') && employeeData && employeeData.id}
                    {#if deleteConfirmation}
                        <div class="alert alert-warning btn-block">
                            <h4>
                                Are you sure you want to
                                {#if params.subMenu === 'activity' }
                                    remove?
                                {:else}
                                    delete?
                                {/if}
                            </h4>
                            {#if params.subMenu !== 'activity'}
                                <p>You can set the termination date instead of deleting.</p>
                            {/if}
                        </div>
                        <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteEmployee} disabled={disableButton}>
                            Click to confirm
                        </button>
                    {:else}
                        <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                            {#if params.subMenu === 'activity' }
                                REMOVE
                            {:else}
                                DELETE
                            {/if}
                        </button>
                    {/if}
                {/if}
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-success" on:click={onSaveEmployee} disabled={disableSaveButton}>
                    {#if employeeData && employeeData.id}
                        Update
                    {:else}
                        Save
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editTeam" tabindex="-1" role="dialog" aria-labelledby="editTeam" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editTeamLabel">
                    {#if currentTeam.id}
                        Edit
                    {:else}
                        Add
                    {/if}
                    {#if params.subMenu === 'activity'}
                        Metric
                    {:else}
                        Section
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('EDIT_TEAM') }
                    <ul class="nav nav-tabs mb-2" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="section-edit-tab"
                               data-toggle="tab" href="#sectionEdit" role="tab" aria-controls="kpi"
                               aria-selected="true">
                                {#if params.subMenu === 'activity'}
                                    Metric edit
                                {:else}
                                    Section edit
                                {/if}
                            </a>
                        </li>
                        {#if params.subMenu === 'ptqr'}
                            <li class="nav-item">
                                <a class="nav-link" id="style-tab"
                                   data-toggle="tab" href="#style" role="tab" aria-controls="style"
                                   aria-selected="false">
                                    Section Conditional Formatting
                                </a>
                            </li>
                        {/if}
                        <li class="nav-item">
                            <a class="nav-link" id="ytd-formula-tab"
                               data-toggle="tab" href="#ytdFormula" role="tab" aria-controls="ytdFormula"
                               aria-selected="false">
                                YTD Formula
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        {#if currentTeam.id}
                            <div class="form-group">
                                <strong>Section ID:</strong> {currentTeam.id}
                            </div>
                        {/if}
                        <div class="tab-pane fade show active" id="sectionEdit" role="tabpanel" aria-labelledby="style-tab">
                            <div class="form-group">
                                <label for="teamName">Name:</label>
                                <input bind:value={currentTeam.title} maxlength="64" type="text" class="form-control" id="teamName"
                                       placeholder="Team Name">
                            </div>
                            <div class="form-group">
                                <label for="formatInput">Format:</label>
                                <select bind:value={currentTeam.format} class="form-control" id="formatInput">
                                    {#each formatTitles as name, id}
                                        <option value={id}>{name}</option>
                                    {/each}
                                </select>
                            </div>
                            {#if !currentTeam.title}
                                <small class="text-danger ml-2 font-weight-bold">Name is required</small>
                            {/if}
                        </div>

                        {#if params.subMenu === 'ptqr'}
                            <div class="tab-pane fade " id="style" role="tabpanel" aria-labelledby="style-tab">
                                <div class="form-group">
                                    <label>
                                        <input type=radio name="customStyle"
                                               checked="{ !currentTeam.style || currentTeam.style.length == 0 }"
                                               on:click={() => currentTeam.style=''}>
                                        Default
                                    </label>
                                    <label class="ml-3">
                                        <input type=radio name="customStyle"
                                               checked="{ currentTeam.style && currentTeam.style.length > 0 }"
                                               on:click={() => currentTeam.style=stylesList[3].code}>
                                        Custom
                                    </label>
                                </div>
                                {#if currentTeam.style && currentTeam.style.length > 0 }
                                    <ColorPicker bind:value={currentTeam.style}></ColorPicker>
                                {/if}
                            </div>
                        {/if}
                        <div class="tab-pane fade" id="ytdFormula" role="tabpanel" aria-labelledby="ytd-formula-tab">
                            <div class="form-group">
                                <label for="ytdFormulaInput">Calculate the YTD Formula using: </label>
                                <select bind:value={currentTeam.ytd_formula} class="form-control" id="ytdFormulaInput">
                                    {#each Object.keys(ytdFormulasTitles) as id}
                                        <option value={id}>{ytdFormulasTitles[id]}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
            <div class="modal-footer text-right">
                {#if AuthService.can('DELETE_TEAM') }
                    {#if currentTeam.id}
                        {#if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteTeam}
                                    disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                {#if currentTeam.title}
                    <button type="button" class="btn btn-success " on:click={onSaveTeam} disabled={disableSaveButton}>
                        {#if currentTeam.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                {:else}
                    <button type="button" class="btn btn-danger disabled" disabled={disableSaveButton}>
                        {#if currentTeam.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>

<!-- Onboarded Month Info Modal -->
<div class="modal fade" id="categoryInfoModal" tabindex="-1" role="dialog" aria-labelledby="onboardedMonth" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editSectionLabel">
                    Category Information
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-left">
                {#if categoryInfo == 'onboard_month'}
                    Enter the month when we can make an early judgement on this rep based on their performance. This is not the time that it takes to onboard.
                {:else if categoryInfo == 'onboard_perf'}
                    Enter our minimum performance expectation (in % or actual amount) while this person is in this onboarding month.
                {:else}
                    Enter the month when this position should be fully productive in their role with their ramped peers.
                {/if}
            </div>
        </div>
    </div>
</div>

<!-- Role Metrics Modal -->
<div class="modal fade" id="roleMetricsModal" tabindex="-1" role="dialog" aria-labelledby="editMetricsLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editMetricsLabel">
                    {#if selectedRole && selectedRole.id}
                        <em class="text-dark bg-warning px-1">{selectedRole.title}</em>
                    {:else}
                        New
                    {/if}
                    Role Metrics
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-left">
                {#if !selectedRole}
                    <select bind:value={selectedRole} on:blur={() => selectRole(selectedRole) } class="form-control">
                        <option value={null}>Select a role</option>
                        {#each teams as role}
                            <option value={role}>{role.title}</option>
                        {/each}
                    </select>
                {:else}
                    <p>Select the metrics you want to include in this role.</p>
                    {#if metrics && metrics.length > 0}
                        {#each metrics as metric}
                            <div class="row text-muted">
                                <div class="col-8" on:click|stopPropagation|preventDefault={() => toggleRoleMetric(metric)}>
                                    <div class="form-check ml-4">
                                        {#if roleHasMetricID(metric.id)}
                                            <input class="form-check-input" type="checkbox" id="metric-{metric.id}" checked />
                                        {:else}
                                            <input class="form-check-input" type="checkbox" id="metric-{metric.id}" />
                                        {/if}
                                        <label class="form-check-label me-4 {roleHasMetricID(metric.id)? 'text-dark' : ''}"
                                               for="metric-{metric.id}">
                                            {metric.title}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        {/each}
                    {/if}
                {/if}
            </div>
            <div class="modal-footer">
                {#if AuthService.can('DELETE_EMPLOYEE') && employeeData && employeeData.id}
                    {#if deleteConfirmation}
                        <div class="alert alert-warning btn-block">
                            <h4>
                                Are you sure you want to
                                {#if params.subMenu === 'activity' }
                                    remove?
                                {:else}
                                    delete?
                                {/if}
                            </h4>
                            {#if params.subMenu !== 'activity'}
                                <p>You can set the termination date instead of deleting.</p>
                            {/if}
                        </div>
                        <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteEmployee} disabled={disableButton}>
                            Click to confirm
                        </button>
                    {:else}
                        <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                            {#if params.subMenu === 'activity' }
                                REMOVE
                            {:else}
                                DELETE
                            {/if}
                        </button>
                    {/if}
                {/if}
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-success" on:click={saveRoleMetrics}>
                    Save
                </button>
            </div>
        </div>
    </div>
</div>

{#if params.subMenu === 'activity'}
    <div class="modal fade" id="roleActivityMetricsModal" tabindex="-1" role="dialog" aria-labelledby="editActivityMetricsLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editActivityMetricsLabel">
                        {#if selectedRole && selectedRole.id}
                            <em class="text-dark bg-warning px-1">{selectedRole.title}</em>
                        {:else}
                            New
                        {/if}
                        Activity Role Metrics
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-left">
                    {#if !selectedRole}
                        <select bind:value={selectedRole} on:blur={() => selectRole(selectedRole) } class="form-control">
                            <option value={null}>Select a role</option>
                            {#each teams as role}
                                <option value={role}>{role.title}</option>
                            {/each}
                        </select>
                    {:else}
                    <!-- Tabs hidden for now because we don't need role notes for now-->
                        <!-- <ul class="nav nav-tabs mb-3" id="roleActivityMetricsTabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link {roleMetricsTab === 'metrics' ? 'active' : ''}" id="metrics-tab"
                                href="#" role="tab" aria-controls="metrics" aria-selected={roleMetricsTab === 'metrics'}
                                on:click|preventDefault={() => roleMetricsTab = 'metrics'}>
                                    Metrics
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link {roleMetricsTab === 'notes' ? 'active' : ''}" id="notes-tab"
                                href="#" role="tab" aria-controls="notes" aria-selected={roleMetricsTab === 'notes'}
                                on:click|preventDefault={() => roleMetricsTab = 'notes'}>
                                    Notes
                                </a>
                            </li>
                        </ul> -->
                        <div class="tab-content" id="roleActivityMetricsTabContent">
                            <div class="tab-pane fade {roleMetricsTab === 'metrics' ? 'show active' : ''}" id="metrics" role="tabpanel" aria-labelledby="metrics-tab">
                                <p>Select the metrics you want to include in this role.</p>
                                {#if metrics && metrics.length > 0}
                                    {#each metrics as metric}
                                        <div class="row text-muted">
                                            <div class="col-8" on:click|stopPropagation|preventDefault={() => toggleRoleMetric(metric)}>
                                                <div class="form-check ml-4">
                                                    {#if roleHasMetricID(metric.id)}
                                                        <input class="form-check-input" type="checkbox" id="metric-{metric.id}" checked />
                                                    {:else}
                                                        <input class="form-check-input" type="checkbox" id="metric-{metric.id}" />
                                                    {/if}
                                                    <label class="form-check-label me-4 {roleHasMetricID(metric.id)? 'text-dark' : ''}"
                                                        for="metric-{metric.id}">
                                                        {metric.title}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                            </div>
                            <div class="tab-pane fade {roleMetricsTab === 'notes' ? 'show active' : ''}" id="notes" role="tabpanel" aria-labelledby="notes-tab">
                                <div class="form-group">
                                    <label for="roleNotesInput">Notes</label>
                                    <textarea bind:value={roleActivityNotes} type="text" class="form-control"
                                            id="roleNotesInput" placeholder="Notes for this role" rows="8"></textarea>
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-success" on:click={saveRoleMetrics}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}

{#if loading}
    <Loader fixed={true}></Loader>
{/if}

<div id="comments" class="comment-popover d-none"></div>
<div id="popover-notes" class="comment-popover d-none" ></div>

{#if !teams}
    <h4 class="text-danger text-center">...</h4>
{:else if params.subMenu === 'activity'}
    <EmployeeActivity teams={teams}
                      teamMetrics={teamMetrics}
                      roleFilter={roleFilter}
                      metrics={metrics}
                      selectedActivity={selectedActivity}
                      selectedTeam={selectedTeam}
                      headers={headers}
                      searchText={search}
                      params={params}
                      getDate={getDate}
                      bind:activityYTDValues={activityYTDValues}
                      bind:localIndicatorFields={localIndicatorFields}
                      on:fillEmployee={ (event) => fillEmployee(event.detail) }
                      on:editEmployee={ (event) => editEmployee(event, event.detail.employee, event.detail.team) }
                      on:saveMetricNotes={ (event) => saveMetricNotes(event.detail) }
                      on:selectRole={ (event) => selectRole(event.detail) }></EmployeeActivity>
{:else}
    {#each teams as team, teamIndex}
        {#if selectedTeam}
            <div class="move-here"
                 on:click={ changeTeamPosition(team.id, team.position) }>
                Move here
            </div>
        {/if}
        <div class="table-wrapper { selectedTeam && selectedTeam == team.id ? 'selectedSection' : ''}">
            <table class="table table-sm container-fluid table-weekly selectable-table">
                <thead>
                <tr class="bg-dark text-light">
                    <th class="col-header">
                        {team.title}
                        {#if AuthService.can('EDIT_TEAM') }
                            <i on:click={ () =>  editTeam(team)}
                               class="fa fa-pencil-square-o text-light float-right btn btn-sm px-0"></i>
                            {#if !selectedTeam}
                                <i
                                    class="fa fa-arrows pointer mr-1 mt-1 float-right"
                                    on:click={ onSelectTeam(team.id)}
                                ></i>
                            {/if}
                        {/if}
                    </th>
                    <th class="col-subheader employee-position">Position</th>
                    <th class="col-subheader subheader-date">Date<br>Started</th>
                    <th class="col-subheader subheader-date">End<br>Date</th>
                    {#if ['attainment', 'quarterly', 'performance'].includes(params.subMenu)}
                        {#if params.subMenu != 'performance'}
                            <th class="col-subheader subheader-date">Tenure (months)</th>
                            {#if params.subMenu == 'attainment'}
                                <th class="notFixed rank">
                                            <span class="text-light">Rank
                                                <i class="fa fa-chevron-down"></i>
                                            </span>
                                </th>
                            {/if}
                        {/if}
                        {#each Object.keys(attainmentHeaders) as attainmentHeader}
                            <th class="notFixed">
                                {attainmentHeaders[attainmentHeader].title}
                                <i class="fa fa-info-circle ml-2 mr-1 vertical-middle pointer"
                                   on:click={ () => openCategoryInfo(attainmentHeader) }
                                ></i>
                            </th>
                        {/each}
                    {/if}
                    {#each headers as header}
                        {#if header != 'rank'}
                            <th class="notFixed">
                                {header.replace(/_/g, ' ')}
                            </th>
                        {/if}
                    {/each}
                </tr>
                </thead>
                <tbody>
                {#each team.employees as employee, employeeIndex}
                    <tr>
                        <th class="col-header {allowDrag ? 'rowDropArea' : ''}"
                            draggable="{allowDrag}"
                            on:dragstart={(e) => handleDragStart(e, employee.id, team.id) }
                            on:dragover={(e) => (teamDragged === team.id && employeeDragged !== employee.id? handleDragOver(e): true)}
                            on:dragleave={(e) => (teamDragged === team.id && employeeDragged !== employee.id? handleDragLeave(e): true)}
                            on:drop={(e) => (teamDragged === team.id && employeeDragged !== employee.id? handleDrop(e, team.id, employeeIndex): true) }>
                            {#if employee.notes && employee.notes.length > 0}
                                <i data-notes="{employee.notes}"
                                   class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                            {/if}
                            {#if AuthService.can('EDIT_EMPLOYEE') }
                                <i data-id="{employee.id}"
                                   on:click={ (e) => editEmployee(e, employee) }
                                   class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                            {/if}
                            {employee.name}
                        </th>
                        <td class="col-subheader text-truncate employee-position">{employee.position || ''}</td>
                        <td class="col-date">{employee.start_date_formatted || ''}</td>
                        <td class="col-date">{employee.end_date_formatted || ''}</td>
                        {#if ['attainment', 'quarterly', 'performance'].includes(params.subMenu)}
                            {#if params.subMenu != 'performance'}
                                <td class="col-date">{employee.tenure || ''}</td>
                                {#if params.subMenu == 'attainment'}
                                    <td class="notFixed readOnly rank">
                                        {formatValue(6, employee.employeeData['rank'])}
                                    </td>
                                {/if}
                            {/if}
                            {#each Object.keys(attainmentHeaders) as attainmentHeader, headerIndex}
                                {#if AuthService.can('SE_EDITABLE_METRICS')}
                                    <td class="notFixed">
                                        <EditableCell
                                            id="t{teamIndex}-{employeeIndex}-{headerIndex}"
                                            on:change={(e) => saveEmployeeFields(e.detail.value, employee.id, attainmentHeader)}
                                            bind:value={employee[attainmentHeader]}
                                            customClass="{attainmentHeaders[attainmentHeader].format == 7 ? 'hr-cell': ''}"
                                            xdata="{ {id: employee.id, report: 'employee', field: attainmentHeader, value: employee.attainmentHeader, attainment_header: true } }"
                                            format={attainmentHeaders[attainmentHeader].format}>
                                        </EditableCell>
                                    </td>
                                {:else}
                                    <td class="readOnly">
                                        {formatValue(attainmentHeaders[attainmentHeader].format, employee[attainmentHeader])}
                                    </td>
                                {/if}
                            {/each}
                        {/if}
                        {#if employee && employee.employeeData}
                            {#each Object.keys(employee.employeeData) as id, employeDataIndex}
                                {#if ['performance', 'quota', 'pipeline'].includes(params.subMenu)}
                                    {#if params.subMenu == "quota"}
                                        {#if AuthService.can('EDIT_CELL') && !id.includes('YTD')}
                                            <td class="notFixed">
                                                <EditableCell
                                                    id="t{teamIndex}-{employeeIndex}-{employeDataIndex}"
                                                    customClass="{getPastDateData(employee.employeeData[id], id , 'monthly', null, employee.start_date, employee.end_date)}"
                                                    xdata="{ {id: employee.id, report: 'employee', date: getDate(id), field: params.subMenu, value: employee.employeeData[id] } }"
                                                    on:change={(e) => saveEmployeeStat(e.detail.value, employee.id, id)}
                                                    bind:value={employee.employeeData[id]}
                                                    format={team.format}></EditableCell>
                                            </td>
                                        {:else if id.includes('YTD')}
                                            <td class="notFixed readOnly">
                                                {formatValue(team.format, ytdValues[employee.id])}
                                            </td>
                                        {:else}
                                            <td class="notFixed {getPastDateData(employee.employeeData[id], id , 'monthly', null, employee.start_date, employee.end_date)}">
                                                {formatValue(team.format, employee.employeeData[id])}
                                            </td>
                                        {/if}
                                    {:else}
                                        {#if AuthService.can('EDIT_CELL') && !id.includes('YTD')}
                                            <td class="notFixed">
                                                <EditableCell
                                                    id="t{teamIndex}-{employeeIndex}-{(params.subMenu != 'performance')? employeDataIndex : employeDataIndex+4}"
                                                    xdata="{ {id: employee.id, report: 'employee', date: getDate(id), field: params.subMenu, value: employee.employeeData[id] } }"
                                                    on:change={(e) => saveEmployeeStat(e.detail.value, employee.id, id)}
                                                    bind:value={employee.employeeData[id]}
                                                    format={team.format}></EditableCell>
                                            </td>
                                        {:else if id.includes('YTD')}
                                            <td class="notFixed readOnly">
                                                {formatValue(team.format, ytdValues[employee.id])}
                                            </td>
                                        {:else}
                                            <td class="notFixed">
                                                {formatValue(team.format, employee.employeeData[id])}
                                            </td>
                                        {/if}
                                    {/if}
                                {:else if params.subMenu === 'ptqr'}
                                    <td class="notFixed {getPastDateData(employee.employeeData[id], id , 'monthly', null, employee.start_date, employee.end_date)}
                                                style-{getPtqrCellStyle(Number.parseFloat(employee.employeeData[id]), team.style)} readOnly">
                                        {formatValue(4, employee.employeeData[id])}
                                    </td>
                                {:else}
                                    {#if id == 'rank'}
                                        <!-- Rank added before -->
                                    {:else}
                                        {#if id.includes('Sold')}
                                            <!-- Sold columns don't need style and must be formatted as currency -->
                                            <td class="notFixed">
                                                {formatValue(1, employee.employeeData[id])}
                                            </td>
                                        {:else if employee.employeeData[id] == -1}
                                            <td class="notFixed {getPastDateData(0, id , 'monthly', null, employee.start_date, employee.end_date, true)}">
                                                {formatValue(2, 0)}
                                            </td>
                                        {:else if employee.employeeData[id] > 0}
                                            <td class="notFixed {
                                                employee.employeeData[id] > 80 ? 'style-green':
                                                employee.employeeData[id] >= 50 ? 'style-yellow':
                                                employee.employeeData[id] < 50 && employee.employeeData[id] > 0? 'style-red': ''}
                                            ">
                                                {formatValue(2, employee.employeeData[id])}
                                            </td>
                                        {:else}
                                            {#if params.subMenu == 'attainment'}
                                                <td class="notFixed {getPastDateData(employee.employeeData[id], id , 'monthly', null, employee.start_date, employee.end_date)}">
                                                    {formatValue(2, employee.employeeData[id])}
                                                </td>
                                            {:else}
                                                <td class="notFixed {getPastDateData(employee.employeeData[id], id , 'quarterly', params.year, employee.start_date, employee.end_date)}">
                                                    {formatValue(2, employee.employeeData[id])}
                                                </td>
                                            {/if}
                                        {/if}
                                    {/if}
                                {/if}
                            {/each}
                        {/if}
                    </tr>
                {:else}
                    <tr>
                        <th class="col-header">
                            {#if AuthService.can('EDIT_EMPLOYEE') }
                                <i data-id="{team.id}"
                                   on:click={ (e) => fillEmployee(team) }
                                   class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                            {/if}
                            John Doe
                        </th>
                        <td class="col-subheader text-truncate employee-position">Manager</td>
                        <td class="col-date">---</td>
                        <td class="col-date">---</td>
                        {#if params.subMenu =='attainment' ||  params.subMenu == 'quarterly'}
                            <td class="col-date">---</td>
                            <td class="notFixed readOnly rank">---</td>
                        {/if}

                        {#each headers as header}
                            <td class="notFixed readOnly text-light">&emsp;</td>
                        {/each}
                    </tr>
                {/each}
                <tr class="border-0">
                    <td class="bg-transparent col-header">
                        {#if team.position !== null && AuthService.can('ADD_EMPLOYEE') }
                            <button class="mt-2 btn btn-primary btn-sm text-light float-left"
                                    data-id="{team.id}"
                                    on:click|preventDefault={(e) => fillEmployee(team)}>
                                <i class="fa fa-plus"></i>
                                Add Employee
                            </button>
                        {/if}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    {/each}
{/if}
